import { useEffect, useState } from "react";
import { useLocation } from "react-router";

import { ITabMenuTab } from "@digital-services/ui/types";

export const useTabIndex = (tabs: ITabMenuTab[]) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const { pathname } = useLocation();

  useEffect(() => {
    const tabIndex = tabs.findIndex(({ id }) =>
      pathname.toLowerCase().endsWith("/" + id.toLowerCase())
    );

    if (tabIndex === -1) {
      return setCurrentTabIndex(0);
    }

    setCurrentTabIndex(tabIndex);
    // When we use a constant-like `tabs` variable here as dependency trigger, it goes into WRONG update flow of `setCurrentTabIndex` which causes always be `0`
    // We must ignore `tabs` change, because it's initial data
    // eslint-disable-next-line
  }, [pathname]);

  return {
    currentTabIndex
  };
};
